// One definition of "open this event / venue / source page" for every search
// surface (navbar dropdown, results page, mobile overlay, history). A source
// page (club, festival, radio station, podcast — a v2 `sources` row) carries an
// id: its mixes come by relation (filters.source), never by a title match. A
// mix-title hub ("Tomorrowland", grouped by event_name) has no id and keeps the
// title-filtered list.
import { normalizeEventKind } from './searchSections';

export const eventFilters = (ev) => (ev?.id ? { source: ev.id } : { title: ev?.name || '' });

export const eventFilterContext = (ev) => ({
    kind: 'title',
    titleQuery: ev.name || '',
    eventKind: normalizeEventKind(ev.kind),
    eventType: ev.type || null,
    sourceId: ev.id || null,
    covers: [...(ev.image ? [ev.image] : []), ...(Array.isArray(ev.covers) ? ev.covers : [])].filter(Boolean).slice(0, 4),
    mixCount: ev.mixCount || null,
});

export const eventHistoryEntry = (ev) => ({
    entityType: 'event',
    entityPublicId: ev.id || `q:${ev.name || ''}`,
    entityName: ev.name || '',
    entitySubtitle: ev.type || (ev.mixCount ? `${ev.mixCount} mixes` : null),
    entityArtwork: ev.image || (ev.covers && ev.covers[0]) || null,
    surface: 'mixpedia',
});

// A history row back into an event descriptor: a real id (not the `q:` marker) is a source.
export const eventFromHistory = (entry) => ({
    id: entry.entityPublicId && !String(entry.entityPublicId).startsWith('q:') ? entry.entityPublicId : null,
    name: entry.entityName || '',
    covers: entry.entityArtwork ? [entry.entityArtwork] : [],
});
